/**
 * @fileoverview gRPC-Web generated client stub for adx.color_patterns
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.adx = {};
proto.adx.color_patterns = require('./color_patterns_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.color_patterns.ColorPatternsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.color_patterns.ColorPatternsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.color_patterns.GetColorPatternsRequest,
 *   !proto.adx.color_patterns.GetColorPatternsResponse>}
 */
const methodDescriptor_ColorPatterns_GetColorPatterns = new grpc.web.MethodDescriptor(
  '/adx.color_patterns.ColorPatterns/GetColorPatterns',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.color_patterns.GetColorPatternsRequest,
  proto.adx.color_patterns.GetColorPatternsResponse,
  /**
   * @param {!proto.adx.color_patterns.GetColorPatternsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.color_patterns.GetColorPatternsResponse.deserializeBinary
);


/**
 * @param {!proto.adx.color_patterns.GetColorPatternsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.color_patterns.GetColorPatternsResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.color_patterns.ColorPatternsClient.prototype.getColorPatterns =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.color_patterns.ColorPatterns/GetColorPatterns',
      request,
      metadata || {},
      methodDescriptor_ColorPatterns_GetColorPatterns);
};


/**
 * @param {!proto.adx.color_patterns.GetColorPatternsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.color_patterns.GetColorPatternsResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.color_patterns.ColorPatternsPromiseClient.prototype.getColorPatterns =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.color_patterns.ColorPatterns/GetColorPatterns',
      request,
      metadata || {},
      methodDescriptor_ColorPatterns_GetColorPatterns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.color_patterns.GetColorInfoRequest,
 *   !proto.adx.color_patterns.GetColorInfoResponse>}
 */
const methodDescriptor_ColorPatterns_GetColorInfo = new grpc.web.MethodDescriptor(
  '/adx.color_patterns.ColorPatterns/GetColorInfo',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.color_patterns.GetColorInfoRequest,
  proto.adx.color_patterns.GetColorInfoResponse,
  /**
   * @param {!proto.adx.color_patterns.GetColorInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.color_patterns.GetColorInfoResponse.deserializeBinary
);


/**
 * @param {!proto.adx.color_patterns.GetColorInfoRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.color_patterns.GetColorInfoResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.color_patterns.ColorPatternsClient.prototype.getColorInfo =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.color_patterns.ColorPatterns/GetColorInfo',
      request,
      metadata || {},
      methodDescriptor_ColorPatterns_GetColorInfo);
};


/**
 * @param {!proto.adx.color_patterns.GetColorInfoRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.color_patterns.GetColorInfoResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.color_patterns.ColorPatternsPromiseClient.prototype.getColorInfo =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.color_patterns.ColorPatterns/GetColorInfo',
      request,
      metadata || {},
      methodDescriptor_ColorPatterns_GetColorInfo);
};


module.exports = proto.adx.color_patterns;

